import React, { useEffect, useState } from 'react';
import api from '../services/api';

import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function Events() {
  const [events, setEvents] = useState([]);
  const navigate = useNavigate();
  const { user } = useAuth();

  function ticketPriceFor(ev) {
    if (!ev) return 0;
    return Number(ev.ticket_price ?? ev.ticketPrice ?? ev.price ?? 0) || 0;
  }

  useEffect(() => { api.get('/events').then(r => setEvents(r.data)).catch(() => { }); }, []);

  const featured = events.find(ev => ev.name && ev.name.toLowerCase() === 'autumn play');
  const ordered = featured ? [featured, ...events.filter(e => e.id !== featured.id)] : events;

  return (
    <div className="p-6 events-page">
      <header className="events-hero p-8 rounded-lg mb-6">
        <h2 className="text-3xl hero-title">Upcoming Events</h2>
        <p className="hero-sub">Browse shows, check availability and manage bookings — beautifully presented for managers and guests.</p>
      </header>

      {featured && (
        <div className="mb-6 p-4 bg-gradient-to-r from-indigo-50 to-yellow-50 rounded-lg flex items-center gap-4">
          <div className="w-48 h-28 rounded overflow-hidden" style={{ backgroundImage: `url(/images/auditorium2.jpg)`, backgroundSize: 'cover' }} />
          <div>
            <div className="text-sm text-gray-500">Featured Show</div>
            <div className="font-bold text-xl">{featured.name} — {featured.date} {featured.time}</div>
            <div className="text-sm text-gray-700">{featured.description}</div>
            <div className="mt-2 text-sm text-gray-700">Price per seat: <strong>₹{ticketPriceFor(featured).toFixed(2)}</strong></div>
          </div>
        </div>
      )}

      <div className="events-grid">
        {ordered.map((e, idx) => (
          <article key={e.id} className="event-card">

            <div
              className="event-card-image"
              style={{
                backgroundImage: `url(/images/auditorium${(idx % 3) + 1}.jpg)`
              }}
            />

            <div className="event-card-body">
              <h3 className="event-card-title">{e.name}</h3>

              <div className="event-card-meta">{e.date} • {e.time}</div>

              <div className="event-card-meta">
                Price: <strong>₹{ticketPriceFor(e).toFixed(2)}</strong>
              </div>

              <p className="event-card-desc">{e.description}</p>

              <div className="event-card-actions">
                <button
                  className="btn btn-outline"
                  onClick={() => navigator.clipboard?.writeText(window.location.origin + '/events/' + e.id)}
                >
                  Copy Link
                </button>

                <button
                  className="btn btn-primary"
                  onClick={() => navigate('/bookings?event=' + e.id)}
                >
                  Book
                </button>
              </div>
            </div>

          </article>
        ))}
      </div>


      {/* graceful fallback */}
      {events.length === 0 && <div className="p-4 bg-white rounded shadow mt-4">No events available.</div>}
    </div>
  );
}
